module.exports = __webpack_public_path__ + "img/convertible.8f49a25b.png";